import 'intersection-observer'
import Vue from 'vue'
import WebFont from 'webfontloader'
import MarqueeText from 'vue-marquee-text-component'
import VueTouch from 'vue-touch'
import VueScrollTo from 'vue-scrollto'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/global-styles.js'

Vue.config.productionTip = false

const fonts = [
  'Circular Book',
  'Circular Medium'
]

WebFont.load({
  custom: {
    families: fonts,
    urls: ['/fonts.css']
  },
  active: () => {}
})

VueTouch.registerCustomEvent('singletap', {
  type: 'tap',
  taps: 1
})

VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 2
})

Vue.component('marquee-text', MarqueeText)
Vue.use(VueTouch)
Vue.use(VueScrollTo, {
  duration: 500,
  easing: 'ease',
  offset: -20,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

new Vue({
  created () {
    this.$store.dispatch('GET_API_DATA')
    this.$store.dispatch('GET_TOUCH_STATE')
    this.$store.dispatch('GET_RESIZE_STATE')
    this.$store.dispatch('GET_SCROLL_STATE')
    this.$store.dispatch('GET_USER_AGENT')
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')

console.log('%c Design & Development: DERPYVISION ', 'color: white; background: #FF90EA;')
console.log('🌎 https://derpy.vision')
